export default __webpack_public_path__ + "static/media/vizibly.1d9e806c.svg";